"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreStep = void 0;
var _mui = require("@ori-ui/mui");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = require("react");
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../contexts");
var _interfaces = require("../../interfaces");
var _models = require("../../models");
var _api = require("../../models/api");
var _utils = require("../../utils");
var _Forms = require("../Forms");
var _jsxRuntime = require("react/jsx-runtime");
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  paddingTop: theme.spacing(10)
}));
const PreStep = () => {
  const {
    data: registrationConfig
  } = (0, _api.useRegistrationsMetadata)();
  const {
    data: captcha,
    isValidating
  } = (0, _globalApiClientReact.useGetRequestValidationMetadata)({
    action: 'Registration'
  }, undefined, {
    swr: {
      revalidateOnFocus: false
    }
  });
  const [submitSuccess, setSubmitSuccess] = (0, _react.useState)(false);
  const [captchaVerification, setCaptchaVerification] = (0, _react.useState)(null);
  const [captchaError, setCaptchaError] = (0, _react.useState)(undefined);
  const recaptchaRef = (0, _react.useRef)(null);
  const pbs_owner = _jsCookie.default.get('pbs_owner') ?? '';
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    setErrorData,
    customErrors
  } = errorData;
  const submitErrorLoginType = customErrors?.find(er => er.fieldName === 'LoginType');
  const errorMessage = (0, _utils.getErrorLocalizationByCode)(submitErrorLoginType?.errorCode);
  const {
    registrationType,
    loginRedirectUrl,
    referral
  } = (0, _contexts.useConfiguration)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const api = (0, _globalApiClientReact.useApiClient)();
  const showCaptcha = !isValidating && captcha?.siteKey && captcha.isMandatory;
  const isInternationalPbs = referral?.countryCode?.toLocaleLowerCase() !== tenant;
  const onSubmit = async data => {
    let captchaToken;
    if (captcha?.serviceType === _globalApiClientReact.GlobalSharedRequestValidationDtoServiceType.EnterpriseV3) {
      captchaToken = await recaptchaRef.current?.executeAsync();
    } else {
      captchaToken = captchaVerification;
    }
    const headers = {
      'x-response-key': captchaToken ?? ''
    };
    const isNotSocialNetwork = data.loginType === 'Email' || data.loginType === 'Telephone';
    if (showCaptcha && !captchaToken) {
      setCaptchaError({
        id: _models.TranslationKey.cannotVerifyCaptcha,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.cannotVerifyCaptcha
      });
      return;
    }
    try {
      const currentData = {
        ...data,
        contactEmail: isNotSocialNetwork ? data.contactEmail : undefined,
        contactTelephone: isNotSocialNetwork ? data.contactTelephone : undefined,
        password: isNotSocialNetwork ? data.password : undefined,
        customerId: isInternationalPbs ? undefined : referral?.customerId,
        currentStep: 'Prestep',
        startDate: new Date(),
        sponsorOrigin: isInternationalPbs ? 'InternationalPbs' : 'Pbs',
        internationalPbsCode: isInternationalPbs ? pbs_owner : undefined,
        sponsorNumber: isInternationalPbs ? undefined : referral?.consultantNumber,
        registrationType
      };
      const createResponse = await (0, _globalApiClientReact.createCustomerRegistration)(api, currentData, headers);
      const registrationId = createResponse.data;
      const result = new _models.FetchResult(createResponse.status);
      if (result.isSuccess()) {
        setSubmitSuccess(true);
        if (customErrors && customErrors.length > 0) {
          setErrorData([]);
        }
        const redirectUrl = loginRedirectUrl ? `${loginRedirectUrl}?registrationId=${registrationId}` : `${window.location.href}?registrationId=${registrationId}`;
        const form = document.createElement('form');
        const password = document.createElement('input');
        form.method = 'POST';
        form.action = redirectUrl;
        form.style.display = 'none';
        password.name = 'Password';
        password.value = data.password ?? '';
        form.append(password);
        document.body.append(form);
        form.submit();
      }
    } catch (error) {
      const errorResponse = error;
      if (errorResponse.response?.status === _globalApiClientReact.HttpStatusCodes.status400BadRequest) {
        const {
          Errors
        } = errorResponse.response.data;
        const submitErrors = Errors?.map(er => ({
          fieldName: er.PropertyName,
          errorCode: er.Code
        }));
        if (submitErrors?.length && submitErrors.length > 0) {
          setErrorData(submitErrors);
        } else {
          setErrorData([]);
        }
      } else {
        setNotificationData({
          isOpen: true,
          message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.cannotUpdate,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.cannotUpdate
          }),
          type: _interfaces.MessageType.error
        });
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RootContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "h4",
      sx: {
        fontWeight: 'bold'
      },
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.Prestep_Header,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Prestep_Header
      })
    }), submitErrorLoginType ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
      error: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        ...errorMessage
      })
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Forms.PreStepForm, {
      config: registrationConfig,
      isSuccessSubmit: submitSuccess,
      captchaRef: recaptchaRef,
      showCaptcha: Boolean(showCaptcha),
      captchaConfig: captcha,
      captchaError: captchaError,
      onSubmitForm: onSubmit,
      onVerifyCaptcha: token => setCaptchaVerification(token)
    })]
  });
};
exports.PreStep = PreStep;